export const SET_PATIENT_NUMBER = 'BEREAV.SET_PATIENT_NUMBER';
export const SET_BEREAVEMENT_TABLE = 'BEREAV.SET_BEREAVEMENT_TABLE';
